import { useEffect, useState } from 'react';

function InputUrl({ url, setUrl, httpRgx }) {
 
	const handleUrl = e => setUrl(e.target.value),
			handleClearUrl = () => setUrl('') + setPhone("") + setMessage("") + setaddress("") + setNames("") + setContraseña("") + setSub("") ;
	
	const handleValidateUrl = () => {
		if(url && !httpRgx.test(url)) {
			setUrl(url);
		}
	}

	const [successMessage, setSuccessMessage] = useState(false);
	useEffect(() => {
	  if (successMessage) {
		const timer = setTimeout(() => {
		  setSuccessMessage(false);
		}, 3000);
  
		return () => clearTimeout(timer);
	  }
	}, [successMessage]);

	const [https, sethttps] = useState(true);
	const [http, sethttp] = useState(false);
	const [texto, settexto] = useState(false);
	const [wifii, setwifi] = useState(false);
	const [Whatsapp, setWhatsapp] = useState(false);
	const [SMS, setSMS] = useState(false);
	const [Call, setCall] = useState(false);
	const [Email, setEmail] = useState(false);
	const [Pdf, setPdf] = useState(false);

	const httpss = async () => {
		setEmail(false)
		setCall(false)
		setSMS(false)
		setWhatsapp(false)
		sethttp(false)
		setwifi(false)
		settexto(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		sethttps(true)
	};

	const httpp = async () => {
		setEmail(false)
		setCall(false)
		setSMS(false)
		setWhatsapp(false)
		sethttps(false)
		settexto(false)
		setwifi(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		sethttp(true)
	};

	const text = async () => {
		setEmail(false)
		setCall(false)
		setSMS(false)
		setWhatsapp(false)
		sethttps(false)
		setwifi(false)
		sethttp(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		settexto(true)
	};

	const wifi = async () => {
		setEmail(false)
		setCall(false)
		setSMS(false)
		setWhatsapp(false)
		sethttps(false)
		sethttp(false)
		settexto(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		setwifi(true)
	};

	const Whap = async () => {
		setEmail(false)
		setCall(false)
		setSMS(false)
		sethttps(false)
		sethttp(false)
		settexto(false)
		setwifi(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		setWhatsapp(true)
	};

	const Mesag = async () => {
		setEmail(false)
		setCall(false)
		setWhatsapp(false)
		sethttps(false)
		sethttp(false)
		settexto(false)
		setwifi(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		setSMS(true)
	};

	const Tel = async () => {
		setEmail(false)
		setWhatsapp(false)
		sethttps(false)
		sethttp(false)
		settexto(false)
		setwifi(false)
		setSMS(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		setCall(true)
	};

	const emai = async () => {
		setCall(false)
		setWhatsapp(false)
		sethttps(false)
		sethttp(false)
		settexto(false)
		setwifi(false)
		setSMS(false)
		setSub("")
		setPhone("")
		setMessage("")
		setaddress("")
		setUrl('') 
		setEmail(true)
	};

	const pdf = async () => {
		window.open("https://accounts.codeflex.com.co" , "_top")
	};

	const [Names, setNames] = useState('');
	const [selected, setSelected] = useState('');
	const [Contraseña, setContraseña] = useState('');
	const [Phone, setPhone] = useState('');
	const [Message, setMessage] = useState('');
	const [Contry, setContry] = useState('+57');
	const [address, setaddress] = useState('');
	const [Sub, setSub] = useState('');

	const Data = async () => {
		if(Names && selected && Contraseña){
			const datos = Names+selected+Contraseña+";H:true;;";
			setUrl(datos);
			setSuccessMessage(true);
		}
	};

	const Data2 = async () => {
		if(Phone && Contry && Message){
			const datos = "https://wa.me/"+Contry+Phone+"/?text="+Message;
			setUrl(datos);
			setSuccessMessage(true);
		}
	};

	const Data3 = async () => {
		if(Phone && Contry && Message){
			const datos = "SMSTO:"+Contry+Phone+":"+Message;
			setUrl(datos);
			setSuccessMessage(true);
		}
	};

	const Data4 = async () => {
		if(Phone && Contry ){
			const datos = "tel:"+Contry+Phone;
			setUrl(datos);
			setSuccessMessage(true);
		}
	}; 

	const Data5 = async () => {
		if(address && Sub && Message){
			const datos = "MATMSG:TO:"+address+";SUB:"+Sub+";BODY:"+Message+";;";
			setUrl(datos);
			setSuccessMessage(true);
		}
	};
   
	return(
		<div className="relative">
			 
			<div> 
				<button onClick={httpss} type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>https://</button>&nbsp;
				<button onClick={httpp}  type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>http://</button>&nbsp;
				<button onClick={text}   type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Texto</button>&nbsp;
				<button onClick={wifi}   type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Wifi</button>
			</div>
			<div>
				<button onClick={Whap} type="button" style={{ width: "80px", cursor: "pointer", display: "inline-block" }}>Whatsapp</button>&nbsp;
				<button onClick={Mesag} type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>SMS</button>&nbsp;
				<button onClick={Tel} type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Call</button>&nbsp;
				<button onClick={emai} type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Correo</button>
			</div>
			<div>
				<button onClick={pdf}   type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Pdf</button>&nbsp;
				<button onClick={pdf}   type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Video</button>&nbsp;
				<button onClick={pdf}   type="button" style={{ width: "65px", cursor: "pointer", display: "inline-block" }}>Imagen</button>
			</div>
  	 
			{https && (
			<> 
				<label htmlFor="url">Introduce tu URL https://</label>
				<input
					id="url"
					name="url"
					type="text"
					value={url || "https://"}
					onChange={handleUrl}
					onBlur={handleValidateUrl}
					placeholder="Agregar valor para la generación de código Qr"
					required
				/>
			</>
			)}

			{http && (
			<>
				<label htmlFor="url">Introduce tu URL http://</label>
				<input
					id="url"
					name="url"
					type="text"
					value={url || "http://"}
					onChange={handleUrl}
					onBlur={handleValidateUrl}
					placeholder="Agregar valor para la generación de código Qr"
					required
				/>
			</>
			)}

			{texto && (
			<>
				<label htmlFor="url">Introduce tu Texto</label>
				<input
					id="url"
					name="url"
					type="text"
					value={url}
					onChange={handleUrl}
					placeholder="Agregar valor para la generación de código Qr"
					required
				/>
			</>
			)}

			{wifii && (
			<>
				<label htmlFor="url">Network name</label>
				<input
					id="url"
					name="url"
					type="text"
					value={Names || "WIFI:S:"} 
					onChange={(e) => setNames(e.target.value)}
					placeholder="Network name"
					required
				/> 
				<label htmlFor="url">Network type</label><br/>
				<div className="select-styled">
					<select onChange={(e) => setSelected(e.target.value)} required>
						<option selected value={''}></option>
						<option value={';T:WEB;'}>WEB</option>
						<option value={';T:WPA;'}>WPA/WPA2</option>
					</select>
				</div><br/>

				<label htmlFor="url">Password</label><br/>
				<input
					id="url"
					name="url"
					type="text"
					value={Contraseña || "P:"} 
					onChange={(e) => setContraseña(e.target.value)}
					placeholder="Password"
					required
				/> 
				{successMessage && (
				<>
				  <p style={{color:"blue"}}>Codigo QR Generado con exito.</p>
				</>
				)} 
				<button type='button'  style={{cursor:"pointer" , background:"orange"}} onClick={Data}>Generar QR</button>
			</>
			)}


			{Whatsapp && (
			<>
				<label htmlFor="url">Country code</label><br/>
				<div className="select-styled">
					<select className='codigo' value={Contry} onChange={(e) => setContry(e.target.value)}>
                      <option value="+1">+1</option>
                      <option value="+7">+7</option>
                      <option value="+20">+20</option>
                      <option value="+27">+27</option>
                      <option value="+30">+30</option>
                      <option value="+31">+31</option>
                      <option value="+32">+32</option>
                      <option value="+33">+33</option>
                      <option value="+34">+34</option>
                      <option value="+36">+36</option>
                      <option value="+39">+39</option>
                      <option value="+40">+40</option>
                      <option value="+41">+41</option>
                      <option value="+41">+43</option>
                      <option value="+44">+44</option>
                      <option value="+45">+45</option>
                      <option value="+46">+46</option>
                      <option value="+47">+47</option>
                      <option value="+48">+48</option>
                      <option value="+49">+49</option>
                      <option value="+51">+51</option>
                      <option value="+52">+52</option>
                      <option value="+53">+53</option>
                      <option value="+54">+54</option>
                      <option value="+55">+55</option>
                      <option value="+56">+56</option>
                      <option value="+57" >+57</option>
                      <option value="+58">+58</option>
                      <option value="+60">+60</option>
                      <option value="+61">+61</option>
                      <option value="+62">+62</option>
                      <option value="+63">+63</option>
                      <option value="+64">+64</option>
                      <option value="+65">+65</option>
                      <option value="+66">+66</option>
                      <option value="+81">+81</option>
                      <option value="+82">+82</option>
                      <option value="+84">+84</option>
                      <option value="+86">+86</option>
                      <option value="+90">+90</option>
                      <option value="+91">+91</option>
                      <option value="+92">+92</option>
                      <option value="+93">+93</option>
                      <option value="+94">+94</option>
                      <option value="+95">+95</option>
                      <option value="+98">+98</option>
                      <option value="+212">+212</option>
                      <option value="+213">+213</option>
                      <option value="+216">+216</option>
                      <option value="+218">+218</option>
                      <option value="+220">+220</option>
                      <option value="+221">+221</option>
                      <option value="+222">+222</option>
                      <option value="+223">+223</option>
                      <option value="+224">+224</option>
                      <option value="+225">+225</option>
                      <option value="+226">+226</option>
                      <option value="+227">+227</option>
                      <option value="+228">+228</option>
                      <option value="+229">+229</option>
                      <option value="+230">+230</option>
                      <option value="+231">+231</option>
                      <option value="+232">+232</option>
                      <option value="+233">+233</option>
                      <option value="+234">+234</option>
                      <option value="+235">+235</option>
                      <option value="+236">+236</option>
                      <option value="+237">+237</option>
                      <option value="+238">+238</option>
                      <option value="+239">+239</option>
                      <option value="+240">+240</option>
                      <option value="+241">+241</option>
                      <option value="+242">+242</option>
                      <option value="+243">+243</option>
                      <option value="+244">+244</option>
                      <option value="+245">+245</option>
                      <option value="+246">+246</option>
                      <option value="+248">+248</option>
                      <option value="+249">+249</option>
                      <option value="+250">+250</option>
                      <option value="+251">+251</option>
                      <option value="+252">+252</option>
                      <option value="+253">+253</option>
                      <option value="+254">+254</option>
                      <option value="+255">+255</option>
                      <option value="+256">+256</option>
                      <option value="+257">+257</option>
                      <option value="+258">+258</option>
                      <option value="+260">+260</option>
                      <option value="+261">+261</option>
                      <option value="+262">+262</option>
                      <option value="+263">+263</option>
                      <option value="+264">+264</option>
                      <option value="+265">+265</option>
                      <option value="+266">+266</option>
                      <option value="+267">+267</option>
                      <option value="+268">+268</option>
                      <option value="+269">+269</option>
                      <option value="+290">+290</option>
                      <option value="+291">+291</option>
                      <option value="+297">+297</option>
                      <option value="+298">+298</option>
                      <option value="+299">+299</option>   
                      <option value="+380">+380</option>
                      <option value="+502">+502</option>
                      <option value="+505">+505</option>
                      <option value="+506">+506</option>
                      <option value="+507">+507</option>
                      <option value="+591">+591</option>
                      <option value="+593">+593</option>
                      <option value="+595">+595</option>
                      <option value="+598">+598</option> 
                    </select>
				</div><br/>

				<label htmlFor="url">Phone number</label><br/>
				<input
					id="url"
					name="url"
					type="number"
					value={Phone} 
					onChange={(e) => setPhone(e.target.value)}
					placeholder="Phone number"
					required
				/> 
				<label htmlFor="url">Message</label><br/>
				<input
					id="url"
					name="url"
					type="text"
					value={Message} 
					onChange={(e) => setMessage(e.target.value)}
					placeholder="Message"
					required
				/> 
				{successMessage && (
				<>
				  <p style={{color:"blue"}}>Codigo QR Generado con exito.</p>
				</>
				)} 
				<button type='button'  style={{cursor:"pointer" , background:"orange"}} onClick={Data2}>Generar QR</button>
			</>
			)} 


			{SMS && (
			<>
				<label htmlFor="url">Country code</label><br/>
				<div className="select-styled">
					<select className='codigo' value={Contry} onChange={(e) => setContry(e.target.value)}>
                      <option value="+1">+1</option>
                      <option value="+7">+7</option>
                      <option value="+20">+20</option>
                      <option value="+27">+27</option>
                      <option value="+30">+30</option>
                      <option value="+31">+31</option>
                      <option value="+32">+32</option>
                      <option value="+33">+33</option>
                      <option value="+34">+34</option>
                      <option value="+36">+36</option>
                      <option value="+39">+39</option>
                      <option value="+40">+40</option>
                      <option value="+41">+41</option>
                      <option value="+41">+43</option>
                      <option value="+44">+44</option>
                      <option value="+45">+45</option>
                      <option value="+46">+46</option>
                      <option value="+47">+47</option>
                      <option value="+48">+48</option>
                      <option value="+49">+49</option>
                      <option value="+51">+51</option>
                      <option value="+52">+52</option>
                      <option value="+53">+53</option>
                      <option value="+54">+54</option>
                      <option value="+55">+55</option>
                      <option value="+56">+56</option>
                      <option value="+57" >+57</option>
                      <option value="+58">+58</option>
                      <option value="+60">+60</option>
                      <option value="+61">+61</option>
                      <option value="+62">+62</option>
                      <option value="+63">+63</option>
                      <option value="+64">+64</option>
                      <option value="+65">+65</option>
                      <option value="+66">+66</option>
                      <option value="+81">+81</option>
                      <option value="+82">+82</option>
                      <option value="+84">+84</option>
                      <option value="+86">+86</option>
                      <option value="+90">+90</option>
                      <option value="+91">+91</option>
                      <option value="+92">+92</option>
                      <option value="+93">+93</option>
                      <option value="+94">+94</option>
                      <option value="+95">+95</option>
                      <option value="+98">+98</option>
                      <option value="+212">+212</option>
                      <option value="+213">+213</option>
                      <option value="+216">+216</option>
                      <option value="+218">+218</option>
                      <option value="+220">+220</option>
                      <option value="+221">+221</option>
                      <option value="+222">+222</option>
                      <option value="+223">+223</option>
                      <option value="+224">+224</option>
                      <option value="+225">+225</option>
                      <option value="+226">+226</option>
                      <option value="+227">+227</option>
                      <option value="+228">+228</option>
                      <option value="+229">+229</option>
                      <option value="+230">+230</option>
                      <option value="+231">+231</option>
                      <option value="+232">+232</option>
                      <option value="+233">+233</option>
                      <option value="+234">+234</option>
                      <option value="+235">+235</option>
                      <option value="+236">+236</option>
                      <option value="+237">+237</option>
                      <option value="+238">+238</option>
                      <option value="+239">+239</option>
                      <option value="+240">+240</option>
                      <option value="+241">+241</option>
                      <option value="+242">+242</option>
                      <option value="+243">+243</option>
                      <option value="+244">+244</option>
                      <option value="+245">+245</option>
                      <option value="+246">+246</option>
                      <option value="+248">+248</option>
                      <option value="+249">+249</option>
                      <option value="+250">+250</option>
                      <option value="+251">+251</option>
                      <option value="+252">+252</option>
                      <option value="+253">+253</option>
                      <option value="+254">+254</option>
                      <option value="+255">+255</option>
                      <option value="+256">+256</option>
                      <option value="+257">+257</option>
                      <option value="+258">+258</option>
                      <option value="+260">+260</option>
                      <option value="+261">+261</option>
                      <option value="+262">+262</option>
                      <option value="+263">+263</option>
                      <option value="+264">+264</option>
                      <option value="+265">+265</option>
                      <option value="+266">+266</option>
                      <option value="+267">+267</option>
                      <option value="+268">+268</option>
                      <option value="+269">+269</option>
                      <option value="+290">+290</option>
                      <option value="+291">+291</option>
                      <option value="+297">+297</option>
                      <option value="+298">+298</option>
                      <option value="+299">+299</option>   
                      <option value="+380">+380</option>
                      <option value="+502">+502</option>
                      <option value="+505">+505</option>
                      <option value="+506">+506</option>
                      <option value="+507">+507</option>
                      <option value="+591">+591</option>
                      <option value="+593">+593</option>
                      <option value="+595">+595</option>
                      <option value="+598">+598</option> 
                    </select>
				</div><br/>

				<label htmlFor="url">Phone number</label><br/>
				<input
					id="url"
					name="url"
					type="number"
					value={Phone} 
					onChange={(e) => setPhone(e.target.value)}
					placeholder="Phone number"
					required
				/> 
				<label htmlFor="url">Message SMS</label><br/>
				<input
					id="url"
					name="url"
					type="text"
					value={Message} 
					onChange={(e) => setMessage(e.target.value)}
					placeholder="Message"
					required
				/> 
				{successMessage && (
				<>
				  <p style={{color:"blue"}}>Codigo QR Generado con exito.</p>
				</>
				)} 
				<button type='button'  style={{cursor:"pointer" , background:"orange"}} onClick={Data3}>Generar QR</button>
			</>
			)} 


			{Call && (
			<>
				<label htmlFor="url">Country code</label><br/>
				<div className="select-styled">
					<select className='codigo' value={Contry} onChange={(e) => setContry(e.target.value)}>
                      <option value="+1">+1</option>
                      <option value="+7">+7</option>
                      <option value="+20">+20</option>
                      <option value="+27">+27</option>
                      <option value="+30">+30</option>
                      <option value="+31">+31</option>
                      <option value="+32">+32</option>
                      <option value="+33">+33</option>
                      <option value="+34">+34</option>
                      <option value="+36">+36</option>
                      <option value="+39">+39</option>
                      <option value="+40">+40</option>
                      <option value="+41">+41</option>
                      <option value="+41">+43</option>
                      <option value="+44">+44</option>
                      <option value="+45">+45</option>
                      <option value="+46">+46</option>
                      <option value="+47">+47</option>
                      <option value="+48">+48</option>
                      <option value="+49">+49</option>
                      <option value="+51">+51</option>
                      <option value="+52">+52</option>
                      <option value="+53">+53</option>
                      <option value="+54">+54</option>
                      <option value="+55">+55</option>
                      <option value="+56">+56</option>
                      <option value="+57" >+57</option>
                      <option value="+58">+58</option>
                      <option value="+60">+60</option>
                      <option value="+61">+61</option>
                      <option value="+62">+62</option>
                      <option value="+63">+63</option>
                      <option value="+64">+64</option>
                      <option value="+65">+65</option>
                      <option value="+66">+66</option>
                      <option value="+81">+81</option>
                      <option value="+82">+82</option>
                      <option value="+84">+84</option>
                      <option value="+86">+86</option>
                      <option value="+90">+90</option>
                      <option value="+91">+91</option>
                      <option value="+92">+92</option>
                      <option value="+93">+93</option>
                      <option value="+94">+94</option>
                      <option value="+95">+95</option>
                      <option value="+98">+98</option>
                      <option value="+212">+212</option>
                      <option value="+213">+213</option>
                      <option value="+216">+216</option>
                      <option value="+218">+218</option>
                      <option value="+220">+220</option>
                      <option value="+221">+221</option>
                      <option value="+222">+222</option>
                      <option value="+223">+223</option>
                      <option value="+224">+224</option>
                      <option value="+225">+225</option>
                      <option value="+226">+226</option>
                      <option value="+227">+227</option>
                      <option value="+228">+228</option>
                      <option value="+229">+229</option>
                      <option value="+230">+230</option>
                      <option value="+231">+231</option>
                      <option value="+232">+232</option>
                      <option value="+233">+233</option>
                      <option value="+234">+234</option>
                      <option value="+235">+235</option>
                      <option value="+236">+236</option>
                      <option value="+237">+237</option>
                      <option value="+238">+238</option>
                      <option value="+239">+239</option>
                      <option value="+240">+240</option>
                      <option value="+241">+241</option>
                      <option value="+242">+242</option>
                      <option value="+243">+243</option>
                      <option value="+244">+244</option>
                      <option value="+245">+245</option>
                      <option value="+246">+246</option>
                      <option value="+248">+248</option>
                      <option value="+249">+249</option>
                      <option value="+250">+250</option>
                      <option value="+251">+251</option>
                      <option value="+252">+252</option>
                      <option value="+253">+253</option>
                      <option value="+254">+254</option>
                      <option value="+255">+255</option>
                      <option value="+256">+256</option>
                      <option value="+257">+257</option>
                      <option value="+258">+258</option>
                      <option value="+260">+260</option>
                      <option value="+261">+261</option>
                      <option value="+262">+262</option>
                      <option value="+263">+263</option>
                      <option value="+264">+264</option>
                      <option value="+265">+265</option>
                      <option value="+266">+266</option>
                      <option value="+267">+267</option>
                      <option value="+268">+268</option>
                      <option value="+269">+269</option>
                      <option value="+290">+290</option>
                      <option value="+291">+291</option>
                      <option value="+297">+297</option>
                      <option value="+298">+298</option>
                      <option value="+299">+299</option>   
                      <option value="+380">+380</option>
                      <option value="+502">+502</option>
                      <option value="+505">+505</option>
                      <option value="+506">+506</option>
                      <option value="+507">+507</option>
                      <option value="+591">+591</option>
                      <option value="+593">+593</option>
                      <option value="+595">+595</option>
                      <option value="+598">+598</option> 
                    </select>
				</div><br/>
				<label htmlFor="url">Phone number</label><br/>
				<input
					id="url"
					name="url"
					type="number"
					value={Phone} 
					onChange={(e) => setPhone(e.target.value)}
					placeholder="Phone number"
					required
				/> 
				{successMessage && (
				<>
				  <p style={{color:"blue"}}>Codigo QR Generado con exito.</p>
				</>
				)} 
				<button type='button'  style={{cursor:"pointer" , background:"orange"}} onClick={Data4}>Generar QR</button>
			</>
			)} 


			{Email && (
			<>
				<label htmlFor="url">Your Emai Address</label><br/>
				<input
					id="url"
					name="url"
					type="text"
					value={address} 
					onChange={(e) => setaddress(e.target.value)}
					placeholder="Your Emai Address"
					required
				/> 
				<label htmlFor="url">Subject Of Email</label><br/>
				<input
					id="url"
					name="url"
					type="text"
					value={Sub} 
					onChange={(e) => setSub(e.target.value)}
					placeholder="Subject Of Email"
					required
				/> 
 
				<label htmlFor="url">Message</label><br/>
				<input
					id="url"
					name="url"
					type="text"
					value={Message} 
					onChange={(e) => setMessage(e.target.value)}
					placeholder="Message"
					required
				/> 
				{successMessage && (
				<>
				  <p style={{color:"blue"}}>Codigo QR Generado con exito.</p>
				</>
				)} 
				<button type='button'  style={{cursor:"pointer" , background:"orange"}} onClick={Data5}>Generar QR</button>
			</>
			)} 

			{url &&
				<button className="clear-btn" style={{cursor:"pointer"}} onClick={handleClearUrl}>x</button>
			}
		</div>
	);
} 

export default InputUrl;